import { useNavigate } from 'react-router';

import success from '../../../assets/images/successIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function SuccessMessagePopup() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const popupProps = useAppSelector((state) => state.popup.popupProps);
  const title = popupProps?.title || 'Успешно!';
  const subtitle = popupProps?.subtitle || '';
  const buttonText = popupProps?.buttonText || 'Хорошо';

  const handleClosePopup = () => {
    dispatch(closePopup());
    navigate('/orders');
  };

  return (
    <div className={styles.successMessagePopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.successMessageTextWrapper}>
        <img src={success} alt="иконка успех" />
        <h2 className={styles.successMessageTitle}>{title}</h2>
        <h3 className={styles.successMessageSubTitle}>{subtitle}</h3>
      </div>
      <RedButton text={buttonText} onClick={handleClosePopup} width={308} height={50} />
    </div>
  );
}

export default SuccessMessagePopup;
